import { usePostConsultarContratoStatus } from "data/api/gestao/contratos/post-consultar-contrato-status"
import { useCallback, useEffect } from "react";
import { TextFieldSaurus } from "views/components/controles/inputs";
import { CircularLoading } from "views/components/utils";

interface CampoContratoStatusProps {
    contratoId: string
    setJsonResultado: React.Dispatch<React.SetStateAction<string>>
    jsonResultado: string
}

export const CampoContratoStatus = ({ contratoId, jsonResultado, setJsonResultado }: CampoContratoStatusProps) => {

    const { postConsultarContratoStatus, carregando } = usePostConsultarContratoStatus();

    const consultarContratoStatus = useCallback(
        async () => {
            const contrato = {
                contratoId: contratoId,
                detalharClientes:true,
                detalharModulos: true
            }
            const res = await postConsultarContratoStatus(contrato);

            if (res.erro) {
                console.log(res.erro.message)
            }
            
            const objString = JSON.stringify(res.resultado?.data)

            setJsonResultado(objString);

        }, [contratoId, postConsultarContratoStatus, setJsonResultado]
    )

    useEffect(() => {
        consultarContratoStatus()
    }, [consultarContratoStatus])

    return (
        <>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <TextFieldSaurus
                multiline
                readOnly
                fullWidth
                size="medium"
                value={jsonResultado}
            />
        </>

    )
}